/* eslint-disable @nx/enforce-module-boundaries */
import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Stack,
  Text,
  IconButton,
  Flex,
  Box,
  useDisclosure,
  HStack,
  Heading,
  RadioGroup,
  Radio,
} from '@mybridge/ui';
import { forwardRef, useContext, useState, useEffect, useMemo } from 'react';
import { JobsListingContext } from '../context';
import { ChevronRightIcon, CheckIcon } from '@chakra-ui/icons';
import { ModalFooter } from '@mybridge/ui/modal';
import { Controller, useForm } from 'react-hook-form';
import { ArrowRight, TagTick, TickMarkIcon } from '@mybridge/icons';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
export const ReportJobModal = forwardRef(({ ...props }, ref) => {
  const [selectedReason, setSelectedReason] = useState();
  const { reportDisc, jobToReport, reportJob,errorExistCompany, reportJobIsLoading } =
    useContext(JobsListingContext);
  const [isFirstModalOpen, setFirstModalOpen] = useState(false);
  const [isSecondModalOpen, setSecondModalOpen] = useState(false);
  const [openModal, setOpenModal] = useState({ open: false, data: '' });
  const { t } = useTranslator();

  const submitReport = async (message) => {
    if (jobToReport?.id) {
      const payload = {
        job_id: jobToReport.id,
        message: message,
      };
      await reportJob(payload);
      setSecondModalOpen(false); // Close the second modal
      setFirstModalOpen(false); // Ensure the first modal is also closed
    }
  };
  const blockReportReasons = useMemo(() => [
    {
      title: t('otherModules.fakeJob') || 'Fake job',
    },
    {
      title: t('otherModules.inappropriatePosting') || 'Posting inappropriate things',
    },
    {
      title: t('otherModules.somethingNotRight') || "Something's not right",
    },
  ]);

  const handleDetailOpen = (reason) => {
    setSelectedReason(reason);
    setFirstModalOpen(false); // Close the first modal
    setSecondModalOpen(true); // Open the second modal
  };

  const handleDetailClose = () => {
    setSecondModalOpen(false); // Close the second modal
    setFirstModalOpen(true); // Reopen the first modal
  };

  const { control } = useForm();



  return (
    <>
      <Modal {...(reportDisc ?? {})} {...props}>
        <ModalOverlay />
        {jobToReport?.id ? (
          <ModalContent minW={["300px","559px"]} maxW={['sm','md']}>
            <form>
              <ModalHeader
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                {/* Centering the text */}
                <Text color={'#3D5A80'} fontWeight={400} lineHeight={'24px'}>
                  {t('otherModules.reportJobTitle') || "Report this job"}
                </Text>
                <ModalCloseButton />
              </ModalHeader>
              <hr
                style={{
                  width: '90%',
                  margin: '0 auto',
                  padding: '0 10px',
                  border: '1 px solid #F6F6F6',
                }}
              />
              <ModalBody mb={6}>
                <Heading
                  pl={1}
                  fontSize={'18px'}
                  color={'#3D5A80'}
                  fontWeight={400}
                  lineHeight={'36px'}
                >
                  {t('otherModules.selectProblem') || "Please select a problem"}
                </Heading>
                <Text mb={6} pl={1}>
                  {
                    t('otherModules.immediateDangerWarning') || "If someone is in immediate danger, get help before reporting to myBridge. Don't wait."
                  }
                </Text>

                <Controller
                  name="message"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <Stack spacing={3}>
                      {blockReportReasons?.map((rm, rmIndex) => (
                        <Box
                          key={rmIndex}
                          cursor="pointer"
                          _hover={{ bg: 'gray.100' }}
                          display="flex"
                          padding="5px"
                          paddingLeft="10px"
                          borderRadius="md"
                          justifyContent="space-between" // Add this line
                          alignItems="center"
                          onClick={() => {
                            submitReport( rm.title);
                            onChange(rm.title); // Update the form value
                            setOpenModal({ open: true, data: rm.title });

                            // handleOptionSelect(rm);  // Call if you need to handle selection
                          }}
                          pr={3} // Apply padding to the right side only
                          pl={3}
                        >
                          <Box>
                            <Text>{rm.title}</Text>
                          </Box>
                          <ArrowRight ml="auto" />
                        </Box>
                      ))}
                    </Stack>
                  )}
                />
              </ModalBody>
            </form>
          </ModalContent>
        ) : (
       
          <ModalContent>
            <ModalBody>
              <HStack justifyContent="center">
                <Text>{t('otherModules.invalidJobSelected') || "Invalid job selected!"}</Text>
              </HStack>
            </ModalBody>
          </ModalContent>
        )}
      </Modal>

      {openModal?.open && !errorExistCompany &&(
        <Modal isOpen={openModal?.open} onClose={() => setOpenModal(false)}>
          <ModalOverlay />

          <ModalContent minW={["300px","559px"]}>
            <form>
              <ModalHeader
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <Box mt={5}>
                  <TickMarkIcon />
                </Box>

                {/* Centering the text */}

                <ModalCloseButton />
              </ModalHeader>
              <ModalBody>
                <Text
                  color={'#3D5A80'}
                  fontSize={'20px'}
                  fontWeight={400}
                  lineHeight={'24px'}
                  alignItems="center"
                  display="flex"
                  justifyContent="center"
                >
                  {t('otherModules.reportJobTitle') || "Report this job"}
                </Text>
                <Heading
                  fontSize={'16px'}
                  fontWeight={400}
                  lineHeight={'19.2px'}
                  alignItems="center"
                  justifyContent="center"
                  display="flex"
                  color={'#747474'}
                  padding={'12px'}
                >
                  {t('otherModules.thanksForReportingJob') || "Thanks for reporting job"}
                </Heading>
                <Box
                   pl={1} 
                   bg={'#D9D9D9'} 
                   borderRadius={'10px'} 
                   display={'flex'}
                   alignItems={'center'} // Center vertically
                   justifyContent={'center'} // Center horizontally
                   gap={1}
                   m={"0 22%"}
                   width="auto" // Dynamic width based on content
                >
                  <TagTick />
                  <Text>{openModal?.data}</Text>
                </Box>
              </ModalBody>
              <ModalFooter>
                <Button
                  onClick={() => {
                    setOpenModal(false);
                    reportDisc?.onClose?.();
                  }}
                  variant="primary"
                  borderRadius="full"
                  type="submit"
                  width="100%"
                >
                  {t('buttons.done') || 'Done'}
                </Button>
              </ModalFooter>
            </form>
          </ModalContent>
        </Modal>
      )}
    </>
  );
});
